import styled from 'styled-components';
import { gridSizes, media } from 'utils/style';

import AditionalOption from 'components/summary/AditionalOption/container';

export default styled(AditionalOption)`
  display: flex;

  .payload {
    width: 100%;
  }
  .aditionalOptionWrap {
    position: relative;
    display: flex;
    ${media.lessThan('small')`
      flex-direction: column;
    `}
  }
  .fieldWrapper {
    position: relative;
    margin: 12px 0 ${gridSizes('S')} 0;

    textarea ~ label {
      height: auto;

      span {
        overflow: auto;
        white-space: normal;
      }
    }
  }
  .specialInstructions {
    border-bottom: 1px dashed var(--grey700);
    color: var(--grey700);
    margin: 0;
    font-size: ${gridSizes('M')};
    line-height: 18px;

    ${media.lessThan('small')`
      font-size: 14px;
      line-height: ${gridSizes('M')};
    `}
  }
  .checkboxLabel {
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: flex-start;
    overflow: overlay;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;

    img {
      width: 64px;
      position: relative;
      top: -6px;
      right: 0px;
    }
  }
`;
